"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

var _colors = require("HubStyleTokens/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ", "px;\n  width: 100%;\n  border-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MainSectionInner = _styledComponents.default.div.withConfig({
  displayName: "MainSectionInner",
  componentId: "sc-11hml5w-0"
})(_templateObject(), _constants.MAIN_SECTION_MAX_WIDTH, function (props) {
  return props.divider ? "1px solid " + _colors.GREAT_WHITE : 'none';
});

var _default = MainSectionInner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/layout/MainSectionInner.js
// module id = 159
// module chunks = 209 210 211 212